import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { IonIcon, IonBadge, IonRippleEffect } from '@ionic/react';
import {
  compass,
  chatbubbles,
  calendar,
  gameController,
  personCircle,
} from 'ionicons/icons';
import './Sidebar.css';

interface NavItem {
  label: string;
  icon: string;
  path: string;
  tab: string;
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Discover',  icon: compass,        path: '/tabs/discover',  tab: 'discover'  },
  { label: 'Chats',     icon: chatbubbles,    path: '/tabs/chats',     tab: 'chats'     },
  { label: 'Sessions',  icon: calendar,       path: '/tabs/sessions',  tab: 'sessions'  },
  { label: 'Games',     icon: gameController, path: '/tabs/games',     tab: 'games'     },
  { label: 'Profile',   icon: personCircle,   path: '/tabs/profile',   tab: 'profile'   },
];

interface SidebarProps {
  unreadCount: number;
}

export const Sidebar: React.FC<SidebarProps> = ({ unreadCount }) => {
  const location = useLocation();
  const history = useHistory();

  return (
    <nav className="app-sidebar" aria-label="Main navigation">
      <div className="sidebar-brand">
        <img
          src="/assets/dicecat-logo-composite.svg"
          alt="Dice Cat"
          className="sidebar-brand-logo"
        />
      </div>

      <ul className="sidebar-nav" role="list">
        {NAV_ITEMS.map(({ label, icon, path, tab }) => {
          const isActive = location.pathname.startsWith(`/tabs/${tab}`);
          return (
            <li key={path} role="listitem">
              <button
                className={`sidebar-nav-item ion-activatable ${isActive ? 'active' : ''}`}
                onClick={() => history.push(path)}
                aria-current={isActive ? 'page' : undefined}
                aria-label={label}
              >
                <span className="sidebar-nav-icon-wrap">
                  <IonIcon icon={icon} aria-hidden="true" />
                  {label === 'Chats' && unreadCount > 0 && (
                    <IonBadge color="danger" className="sidebar-unread-badge">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </IonBadge>
                  )}
                </span>
                <span className="sidebar-nav-label">{label}</span>
                <IonRippleEffect />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
